import React from 'react';
import { EMAIL_CONFIG } from '../config/constants';

const Privacy: React.FC = () => {
  return (
    <div className="p-6">
      <div className="card">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white">Politique de Confidentialité</h1>
          <p className="text-dark-400 mt-1">Nous accordons une grande importance à la protection de vos données personnelles</p>
        </div>

        <section className="policy-section space-y-4">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Introduction</h2>
          <p className="text-white">La présente politique de confidentialité a pour but de vous informer sur la manière dont SuiviFinance collecte, utilise et protège vos informations personnelles lorsque vous utilisez notre application mobile.</p>
          <p className="text-white">Nous nous engageons à respecter votre vie privée et à protéger les informations que vous nous confiez. Veuillez lire attentivement cette politique pour comprendre nos pratiques concernant vos données personnelles.</p>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Collecte des Données</h2>
          <p className="text-white">Nous collectons les types d'informations suivants :</p>
          <ul className="list-disc list-inside text-white space-y-1">
            <li><span className="font-semibold text-green-400">Informations que vous nous fournissez :</span> Données financières que vous entrez manuellement dans l'application (revenus, dépenses, budgets, etc.).</li>
            <li><span className="font-semibold text-green-400">Informations collectées automatiquement :</span> Données d'utilisation de l'application et informations techniques sur votre appareil.</li>
          </ul>
          <p className="text-white">Toutes les données financières que vous saisissez sont stockées localement sur votre appareil et ne sont pas transmises à nos serveurs sans votre consentement explicite.</p>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Utilisation des Données</h2>
          <p className="text-white">Nous utilisons vos données personnelles aux fins suivantes :</p>
          <ul className="list-disc list-inside text-white space-y-1">
            <li>Fournir, maintenir et améliorer les fonctionnalités de notre application</li>
            <li>Personnaliser votre expérience utilisateur</li>
            <li>Analyser l'utilisation de l'application pour améliorer nos services</li>
            <li>Détecter et prévenir les problèmes techniques</li>
          </ul>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Stockage et Sécurité des Données</h2>
          <p className="text-white">La sécurité de vos données est notre priorité. Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations personnelles contre tout accès non autorisé, modification, divulgation ou destruction.</p>
          <p className="text-white">Vos données financières sont principalement stockées localement sur votre appareil. Si vous activez la fonctionnalité de sauvegarde, ces données seront chiffrées avant d'être transmises et stockées sur nos serveurs sécurisés.</p>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Partage des Données</h2>
          <p className="text-white">Nous ne vendons, n'échangeons ni ne transférons vos informations personnelles à des tiers sans votre consentement, sauf dans les cas suivants :</p>
          <ul className="list-disc list-inside text-white space-y-1">
            <li>Lorsque cela est nécessaire pour fournir un service que vous avez demandé</li>
            <li>Pour se conformer à une obligation légale</li>
            <li>Pour protéger nos droits, notre propriété ou notre sécurité</li>
          </ul>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Vos Droits</h2>
          <p className="text-white">Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants concernant vos données personnelles :</p>
          <ul className="list-disc list-inside text-white space-y-1">
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification des données inexactes</li>
            <li>Droit à l'effacement (droit à l'oubli)</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
            <li>Droit d'opposition au traitement</li>
          </ul>
          <p className="text-white"><span className="font-semibold text-green-400">Suppression de vos données ou de votre compte :</span> L'application SuiviFinance vous permet de supprimer vos données ou votre compte directement depuis l'application. Pour ce faire, accédez à la section "Paramètres" puis "Données" et sélectionnez "Supprimer mes données / compte". Vous pourrez alors choisir entre supprimer uniquement vos données ou supprimer entièrement votre compte.</p>
          <p className="text-white">Pour exercer vos autres droits ou pour toute question concernant vos données personnelles, veuillez nous contacter à l'adresse email suivante : <a className="text-primary-400 hover:text-primary-300" href={`mailto:${EMAIL_CONFIG.CONTACT}`}>{EMAIL_CONFIG.CONTACT}</a></p>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Cookies et Technologies Similaires</h2>
          <p className="text-white">Notre application peut utiliser des cookies et des technologies similaires pour améliorer votre expérience utilisateur. Vous pouvez configurer votre appareil pour refuser tous les cookies ou pour être averti lorsqu'un cookie est envoyé.</p>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Modifications de la Politique de Confidentialité</h2>
          <p className="text-white">Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une date de mise à jour. Nous vous encourageons à consulter régulièrement cette page pour rester informé des changements.</p>
        </section>

        <section className="policy-section mt-6 space-y-3">
          <h2 className="text-primary-500 text-xl font-semibold border-b border-dark-700 pb-2">Contact</h2>
          <p className="text-white">Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter à :</p>
          <p className="text-white">
            <span className="font-semibold">Email :</span> <a className="text-primary-400 hover:text-primary-300" href={`mailto:${EMAIL_CONFIG.CONTACT}`}>{EMAIL_CONFIG.CONTACT}</a><br />
            <span className="font-semibold">Adresse :</span> La Saint-Quentinoise, Saint-Quentin, France
          </p>
        </section>

        <p className="text-sm text-dark-400 mt-6 text-right">Dernière mise à jour : 18 juin 2025</p>
      </div>
    </div>
  );
};

export default Privacy;


